"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var toText = vis => {
  if (vis && vis.duration && vis.duration > 0 && vis.unit) {
    if (vis.duration > 1) {
      return "".concat(vis.duration, " ").concat(vis.unit, "s");
    }
    return vis.unit;
  }
  return null;
};
var _default = exports.default = {
  toText
};